import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '../../Icon';
import InputBoolean from '../../internals/InputBoolean';

const FileItem = ({
  file,
  onDelete,
  fileSelection,
  checked,
  onCheck,
  showUploadButton
}) => (
  <div
    className={classnames(
      'btn',
      'btn--wide',
      'flex-row',
      'between-xs',
      'bg--grey',
      'text--bold'
    )}
    /* mt-1x does not work because of btn styles get precedence */
    style={showUploadButton ? { marginTop: '0.5rem' } : {}}
  >
    {fileSelection ? (
      <InputBoolean
        type='radio'
        label={file.name}
        name={file.name}
        checked={checked}
        onChange={onCheck}
      />
    ) : (
      <p>{file.name}</p>
    )}
    <Icon element='option' variant='delete' onClick={onDelete} />
  </div>
);

FileItem.propTypes = {
  file: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  showUploadButton: PropTypes.bool,
  fileSelection: PropTypes.bool,
  checked: PropTypes.bool,
  onCheck: PropTypes.func
};

export default FileItem;
